import React, { Component } from 'react';
import axios from 'axios';
import { kinetik_api_url } from '../../utilities/const';
import WindowAlert from '../../common/AlertComponent';

class UpdatePassword extends Component {
    constructor(props){
        super(props);
        this.state = {
            user_current_password: '',
            new_password: '',
            confirm_new_password: '',
            messageType: '',
            message: '',
            isInfoUpdated: false,
        }
    }

    inputHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    updateUserPwHandler = () => {
        let token = localStorage.getItem('authToken');
        let user_current_password =  this.state.user_current_password;
        let new_password =  this.state.new_password;
        let confirm_new_password =  this.state.confirm_new_password;
        if(user_current_password !== '' && new_password !== '' && confirm_new_password !== '') {
            if(new_password === confirm_new_password) {

                let URL = kinetik_api_url + '/update_password';
                axios.put(URL,{
                    token,
                    confirm_new_password,
                    new_password,
                    user_current_password
                })
                .then((result) => {
                    this.setState({
                        messageType: result.data.status,
                        message: result.data.message,
                        isInfoUpdated: true
                    });
                    localStorage.setItem('authToken', result.data.authToken);
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({
                        messageType: "error",
                        message: "err.data.message",
                        isInfoUpdated: true,
                    });
                })
            } else {
                this.setState({
                    messageType: "error",
                    message: "Password doesn't match",
                    isInfoUpdated: true
                });
            }
        } else {
            this.setState({
                messageType: "error",
                message: "Fill out all the fields first",
                isInfoUpdated: true
            });
        }


    }

    handleAlert = () => {
        this.setState({
            isInfoUpdated: false
        })
    }
    render () {
        return (
            <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-8">
                    <div className="brd_tab_cntnt settings_page_profile">
                        <div className="brd_tab_cntnt">
                            <div className="brding_frm_ele user_pw_u_i">
                                <input onChange={this.inputHandler} defaultValue={""} name="user_current_password" type="password" placeholder="Current password" />
                            </div> <br />
                            <div className="brding_frm_ele user_pw_u_i">
                                <input onChange={this.inputHandler} defaultValue={""} name="new_password" type="password" placeholder="New Password" />
                            </div> <br />
                            <div className="brding_frm_ele user_pw_u_i">
                                <input onChange={this.inputHandler} defaultValue={""} name="confirm_new_password" type="password" placeholder="Confirm New Password" />
                            </div> <br />
                            <div className="brding_frm_ele update_pw_btn">
                                <input onClick={this.updateUserPwHandler} id="update_vendor_changes" type="submit" value="UPDATE PROFILE CHANGES" />
                            </div> <br />
                        </div>

                    </div>
                </div>
                <div className="col-md-2"></div>
                <WindowAlert
                    show={this.state.isInfoUpdated}
                    messageType={this.state.messageType}
                    text={this.state.message}
                    onCofirm={this.handleAlert}
                />
            </div>
        )
    }
}

export default UpdatePassword


// WEBPACK FOOTER //
// ./src/app/profile_settings/users/UpdatePassword.js